// Module
var code = "<div class=\"tooltipContent\" data-bind=\"css: cssClass\">\r\n    <component-loading data-bind=\"visible: !text()\"></component-loading>\r\n    <div data-bind=\"html: text, visible: text\"></div>\r\n</div>";
// Exports
module.exports = code;